// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_CELECTIALS = [{
  id: 'celectials_fate',
  factionId: FACTIONS.CELECTIALS,
  name: 'Ткач судеб',
  priceNumens: 18000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.ORANGE,
    PLAYER_COLORS.YELLOW
  ]
}, {
  id: 'celectials_stars',
  factionId: FACTIONS.CELECTIALS,
  name: 'Отец небес',
  priceNumens: 58000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.INDIGO,
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.BLUE,
  ]
}, {
  id: 'celectials_judge',
  factionId: FACTIONS.CELECTIALS,
  name: 'Вселенский судья',
  priceNumens: 100000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.SKY_BLUE,
  ]
}, {
  id: 'celectials_gold_legacy',
  factionId: FACTIONS.CELECTIALS,
  name: 'Небесный воитель',
  priceNumens: 120000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'celectials_ruby_legacy',
  factionId: FACTIONS.CELECTIALS,
  name: 'Архистратиг',
  priceCrystals: 350,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.YELLOW,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
